var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonMobileApp = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M31.985 2.093h-15.97C13.797 2.093 12 4.06 12 6.49v35.113C12 44.032 13.797 46 16.015 46h15.97C34.203 46 36 44.032 36 41.603V6.49c0-2.429-1.797-4.397-4.015-4.397z", fill: fills.light }),
        React.createElement("path", { d: "M19.036 12.037h-2.102a.944.944 0 01-.945-.945V8.99c0-.522.423-.944.945-.944h2.102c.522 0 .944.422.944.944v2.102a.944.944 0 01-.944.945zM25.051 12.037h-2.102a.944.944 0 01-.945-.945V8.99c0-.522.423-.944.945-.944h2.102c.522 0 .945.422.945.944v2.102a.944.944 0 01-.945.945zM31.066 12.037h-2.102a.944.944 0 01-.944-.945V8.99c0-.522.422-.944.944-.944h2.102c.522 0 .945.422.945.944v2.102a.944.944 0 01-.945.945zM19.036 18.04h-2.102a.944.944 0 01-.945-.944v-2.102c0-.522.423-.945.945-.945h2.102c.522 0 .944.423.944.945v2.102a.944.944 0 01-.944.944zM25.051 18.04h-2.102a.944.944 0 01-.945-.944v-2.102c0-.522.423-.945.945-.945h2.102c.522 0 .945.423.945.945v2.102a.944.944 0 01-.945.944zM31.066 18.04h-2.102a.944.944 0 01-.944-.944v-2.102c0-.522.422-.945.944-.945h2.102c.522 0 .945.423.945.945v2.102a.944.944 0 01-.945.944zM19.036 24.046h-2.102a.944.944 0 01-.945-.944V21c0-.522.423-.945.945-.945h2.102c.522 0 .944.423.944.945v2.102a.944.944 0 01-.944.944zM25.051 24.046h-2.102a.944.944 0 01-.945-.944V21c0-.522.423-.945.945-.945h2.102c.522 0 .945.423.945.945v2.102a.944.944 0 01-.945.944z", fill: fills.base }),
        React.createElement("path", { d: "M24 41.991A1.995 1.995 0 1124 38a1.995 1.995 0 110 3.991z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
